import { findRule } from '../Utils';

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'equal_to');
  const params = rule.ruleParams;

  rule.feedback = `${
    vObj.fieldlabel
  } should be equal to ${params}`;

  return value.toString() === params.toString();
};

export { validate };

export default {
  validate,
};

// v-taurus-validator=
// "'equal_to:false,bool'"
// "'equal_to:20,number'"parseInt
// "'equal_to:false,string'"
// "'equal_to:20.32,float'"parseFloat
